import { render, staticRenderFns } from "./AvailableExams.vue?vue&type=template&id=67caac8a&lang=pug&"
import script from "./AvailableExams.vue?vue&type=script&lang=js&"
export * from "./AvailableExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports